import React, { useEffect, useState } from "react";
import TextEditor from '../components/TextEditor';
import axios from "axios";
import Topbar from '../components/topbar'; 
import Sidebar from '../components/sidebar'; 
import Footer from '../components/footer'; 
import Swal from "sweetalert2";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API_ROOMS = `${BASE_URL}admin/getdata/rooms-details.php`;
const API_CATEGORIES = `${BASE_URL}admin/getdata/get_roomname.php`;
const API_AMENITIES = `${BASE_URL}admin/getdata/get_roomamenities.php`;
let response;

const RoomDetails = () => {
  const [rooms, setRooms] = useState([]);
  const [categories, setCategories] = useState([]);
  const [amenities, setAmenities] = useState([]);

  const [form, setForm] = useState({
    name: "",
    category_id: "",
    price: "",
    accommodate: "",
    description: "",
    policy: "",
    amenities: []
  });

  const [editing, setEditing] = useState(null);

  const fetchAll = async () => {
    const r = await axios.get(API_ROOMS);
    const c = await axios.get(API_CATEGORIES);
    const a = await axios.get(API_AMENITIES);

    setRooms(r.data);
    setCategories(c.data);
    setAmenities(a.data);
  };

  useEffect(() => {
    fetchAll();
  }, []);

  const handleCheckbox = (id) => {
    setForm((prev) => {
      const exists = prev.amenities.includes(id);
      return {
        ...prev,
        amenities: exists
          ? prev.amenities.filter((x) => x !== id)
          : [...prev.amenities, id],
      };
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    let response;

    if (editing) {
      response = await axios.post(
        `${API_ROOMS}?action=update`,
        { ...form, id: editing.id }
      );
    } else {
      response = await axios.post(
        `${API_ROOMS}?action=create`,
        form
      );
    }

    // IMPORTANT: check response safely
    if (response.data && response.data.success === false) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Entry",
        text: response.data.message || "Duplicate record found.",
      });
      return;
    }

    // Success
    Swal.fire({
      icon: "success",
      title: editing ? "Updated Successfully" : "Created Successfully",
      timer: 1500,
      showConfirmButton: false,
    });

    setForm({
      name: "",
      category_id: "",
      price: "",
      accommodate: "",
      description: "",
      policy: "",
      amenities: []
    });

    setEditing(null);
    fetchAll();

  } catch (error) {
    console.error("API ERROR:", error);

    Swal.fire({
      icon: "error",
      title: "Server Error",
      text: "Something went wrong!",
    });
  }
};

const handleEdit = (room) => {
  setEditing(room);

  setForm({
    name: room.name || "",
    category_id: room.room_id || "",
    price: room.price || "",
    accommodate: room.accommodate || "",
    description: room.description || "",
    policy: room.policy || "",
    amenities: room.amenities || []
  });
};

  const handleDelete = async (id) => {
    if(window.confirm("Delete room?")) {
      await axios.post(`${API_ROOMS}?action=delete`, { id });
      fetchAll();
    }
  };


  return (
     <div class="header-light sidebar-dark sidebar-expand">
        <Topbar />
        <div class="content-wrapper">
        <Sidebar />  
         <main class="main-wrapper clearfix">
                  <div class="widget-list">

    
      <div className="container mt-4">
      <h3>Room Details</h3>

      <div className="card mt-3">
        <div className="card-header">Add Room</div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            
            <label>Room Category</label>
            <select className="form-control mb-2"
              value={form.category_id}
              onChange={(e)=>setForm({...form, category_id:e.target.value})}
            >
              <option value="">Select Category</option>
              {categories.map(c => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </select>

            <label>Price</label>
            <input type="number" className="form-control mb-2"
              value={form.price}
              onChange={(e)=>setForm({...form, price:e.target.value})}
            />

           

            <label>Accommodate</label>
            <input className="form-control mb-2"
              value={form.accommodate}
              onChange={(e)=>setForm({...form, accommodate:e.target.value})}
            />

            <label>Amenities</label>
            <div className="mb-2">
              {amenities.map(a => (
                <label key={a.id} className="me-3">
                  <input type="checkbox"
                    checked={form.amenities.includes(a.id)}
                    onChange={() => handleCheckbox(a.id)}
                  /> {a.name} &nbsp;
                </label> 
              ))}
            </div>

            <label>Description</label>
            <TextEditor
            key={editing ? `desc-${editing.id}` : "desc-new"}
            value={form.description}
            onChange={(data) =>
              setForm({ ...form, description: data })
            }
          />
           

            <label>Policy</label>

           <TextEditor
            key={editing ? `policy-${editing.id}` : "policy-new"}
            value={form.policy}
            onChange={(data) =>
              setForm({ ...form, policy: data })
            }
          />       
            <br></br>
            <button className="btn btn-primary">
              {editing ? "Update" : "Submit"}
            </button>
          </form>
        </div>
      </div>

      <div className="card mt-4">
        <div className="card-header">View Rooms</div>
        <table className="table table-bordered mb-0">
          <thead>
            <tr>
              <th>#</th>
              
               <th>Description</th>
                <th>Policy</th>
              <th>Category</th>
              <th>Price</th>
              <th>Amenities</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            
            {rooms.map((r, i)=>(
              <tr key={r.id}>
                <td>{i+1}</td>
                
                 <td style={{ maxWidth: "300px" }}
                  dangerouslySetInnerHTML={{ __html: r.description }} ></td>
                 <td style={{ maxWidth: "300px" }}
                  dangerouslySetInnerHTML={{ __html: r.policy }} ></td>
                <td>{r.name}</td>
                <td>{r.price}</td>
                <td>
                 {r.amenities
                  .map(id => amenities.find(a => a.id === id)?.name)
                  .filter(Boolean)
                  .join(", ")
                 }
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-secondary me-2"
                    onClick={()=>handleEdit(r)}
                  >✏️</button> &nbsp; &nbsp;
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={()=>handleDelete(r.id)}
                  >🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
    </div>
    
    </main>
     <Footer />
    </div>
    </div>
  );
};

export default RoomDetails;
